import { ChannelMetadata, CustomSettings, HIDE_COLOR_VALUE } from '../api'

export type ChannelRowData = {
    metadata: ChannelMetadata
    settings: CustomSettings // only meaningful for rows in the Selected panel
}

export type ColorMode = 'default' | 'custom' | 'hidden'

export const getColorMode = (settings: CustomSettings): ColorMode => {
    if (!settings?.customColor) return 'default'

    return settings.customColor === HIDE_COLOR_VALUE ? 'hidden' : 'custom'
}

export const getDotColor = (row: ChannelRowData): string => {
    const mode = getColorMode(row.settings)

    if (mode === 'hidden') return 'var(--gray-400)'

    return mode === 'custom' ? row.settings.customColor : row.metadata.color ?? 'var(--gray-400)'
}

// the color to tint the channel name with, when the Display tab's "tint channel name" option is on -
// null when there's no real color to tint with (hidden mode), so the name falls back to its plain,
// standard text color rather than being tinted the same neutral gray the dot itself renders as
export const getTextTintColor = (row: ChannelRowData): string | null => {
    const mode = getColorMode(row.settings)

    if (mode === 'hidden') return null

    return mode === 'custom' ? row.settings.customColor : row.metadata.color ?? null
}

// a color to seed the native color input with when switching into custom mode, so it doesn't default to black
export const getSeedCustomColor = (row: ChannelRowData): string => {
    if (getColorMode(row.settings) === 'custom') return row.settings.customColor

    return row.metadata.color ?? '#1D3D9F'
}
